<mb-paginator
  [currentPage]="pagination?.current"
  [totalEntries]="pagination?.total"
  [pageSize]="pagination?.limit"
  (pageChange)="updatePage($event)"
></mb-paginator>